import { Box, Image } from "@chakra-ui/react";
export const Logo = () => {
  return (
    <Box style={{ display: "flex", alignItems: "center" }}>
      <Image src={"/images/logo/logo64.png"} alt="Place des bailleurs logo" />
    </Box>
  );
};
